import * as Types from '../constants/actionTypes';
const defaultState = {
    isPending: false,
    program: [],
    error: '',
    portalLogosList: {},
    allPrograms: [],
    countPrograms: 0
}
export const programRender = (state = defaultState, action) => {
    switch (action.type) {
        case Types.PROGRAM_DETAIL:
            return Object.assign({}, state, { isPending: true })
        case Types.PROGRAM_DETAIL_SUCCESS:
            return Object.assign({}, state, { program: action.payload, isPending: false })
        case Types.COUNT_PROGRAMS_SUCCESS:
            return { ...state,
                countPrograms: action.payload
            }
        case Types.PROGRAM_ADD_SUCCESS:
            return {...state, program: [ ...state.program, action.payload.data[0][0] ]}
        case Types.PROGRAM_LIST_ERROR:
            return Object.assign({}, state, { portalListError: action.payload, isPending: false })
        case Types.SET_PORTAL_LIST_ITEM_LOGO:
            const portalLogosList = state.portalLogosList
            const newPortalList = { ...portalLogosList ,
                [`portalLogo_${action.programId}`]: action.selectedPortalLogo
            }
        
            return { ...state,
                portalLogosList: newPortalList
            }
        case Types.ALL_PROGRAMS_LIST:
            return {
                ...state,
                allPrograms: action.allPrograms
            }
        default:
            return state
    }
}